import React, { Component } from 'react';

import './ContactForm.css'
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'admin-on-rest';

var rep;

class MyHelloButton extends Component {

  constructor(props) {
  super(props);

  console.log("props",props.record.type_complaints);
  rep = props.record.type_complaints ? "resources."+props.record.type_complaints+".name" : "-";

}

  render() {
    const { translate } = this.context;
    return (<label>{translate(rep)}</label>);
  }
}

MyHelloButton.contextTypes = {
    translate: PropTypes.func,
};

MyHelloButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(MyHelloButton);



// WEBPACK FOOTER //
// ./src/custom/MyHelloButton.js